module.exports = __webpack_public_path__ + "img/icon-destroy.d89bc041.svg";